import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Projects from "../../api/projects";

interface ProjectItem {
  id: string;
  title?: string;
  slug?: string;
  pimg1: string;
  date?: string;
  location?: string;
}

interface ProjectSectionS2Props {
  ptClass?: string;
}

const settings: import("react-slick").Settings = {
  dots: false,
  arrows: true,
  speed: 1000,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const ClickHandler = (): void => {
  window.scrollTo(10, 0);
};

const ProjectSectionS2: React.FC<ProjectSectionS2Props> = ({ ptClass }) => {
  return (
    <section className={`wpo-portfolio-section-s5 ${ptClass || ""}`}>
      <h2 className="hidden">Our Projects</h2>
      <div className="container-fluid">
        <div className="portfolio-all-items">
          <div className="portfolio-wrap portfolio-wrap-s2 owl-carousel">
            <Slider {...settings}>
              {Projects.slice(6, 12).map((project: ProjectItem, index: number) => (
                <div className="portfolio-items" key={index}>
                  <div className="img-holder">
                    <img src={project.pimg1} alt={project.title || "Project"} />
                    {project.title && (
                      <div className="portfolio-content">
                        <h4>
                          <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>
                            {project.title}
                          </Link>
                        </h4>
                        {project.location && project.date && (
                          <span>
                            {project.location} - {project.date}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSectionS2;
